import { EmployeesService, GetEmployees_Out } from 'src/pehra-ts-client';
import styles from './TransferPoolList.module.css';
import { Box, Button, Typography } from '@mui/material';
import EmployeeItem from '../EmployeeItem';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import EmployeeTable from '../EmployeeTable';

export interface IEmployeeList {
  sampleTextProp?: string;
  officeId: string;
  data: GetEmployees_Out[];
}

const EmployeeList: React.FC<IEmployeeList> = ({ officeId, data }) => {
  return (
    <Box className={styles.container}>
      <Typography variant="h4" className={styles.title}>
        Available For Transfer
      </Typography>
      <Box className={styles.employeeListContainer}>
        <EmployeeTable rows={data} officeId={officeId} />
      </Box>
    </Box>
  );
};

export default EmployeeList;
